import { Controller } from "@hotwired/stimulus";
import { segmentsFor } from "../utils/sms_segments"

export default class extends Controller {
  static targets = ["emailCard", "eventType", "segmentCount", "smsBody", "smsCard", "smsUnavailableNote", "trixEditor"]
  static values = { emailOnlyEventTypeIds: Array }

  connect() {
    this.#toggleSmsCard()
    this.updateSegmentCount()
  }

  insertSmsSmartField(event) {
    const dropdown = event.target.closest("[data-controller='dropdown']")
    dropdown.dataset.dropdownOpenValue = false

    const textarea = this.smsBodyTarget
    textarea.setRangeText(
      event.target.dataset.value.trim(),
      textarea.selectionStart,
      textarea.selectionEnd,
      "end"
    )
    textarea.focus()

    this.updateSegmentCount()
  }

  onEditorBlur() {
    const editor = this.trixEditorTarget.editor
    this.lastCursorPosition = editor.getSelectedRange()
  }

  insertSmartField(event) {
    const dropdown = event.target.closest("[data-controller='dropdown']")
    dropdown.dataset.dropdownOpenValue = false

    const editor = this.trixEditorTarget.editor
    const text = event.target.dataset.value.trim()
    editor.setSelectedRange(this.lastCursorPosition || [0, 0])
    editor.insertString(text)

    this.lastCursorPosition = null
  }

  // Choosing an email-only event takes SMS away, so a template that was texting gets
  // email in its place. Switches the admin turned off themselves are left alone.
  syncSmsAvailability() {
    if (!this.hasSmsCardTarget) return

    const smsCheckbox = this.smsCardTarget.querySelector("[data-header-switch-target='checkbox']")

    if (this.#smsUnavailable() && smsCheckbox.checked) {
      this.#setChannel(this.emailCardTarget, true)
      this.#setChannel(this.smsCardTarget, false)
    }

    this.#toggleSmsCard()
  }

  updateSegmentCount() {
    if (!this.hasSmsBodyTarget) return

    this.segmentCountTarget.textContent = segmentsFor(this.smsBodyTarget.value)
  }

  #setChannel(card, enabled) {
    card.querySelector("[data-header-switch-target='checkbox']").checked = enabled
    card.querySelector("[data-toggle-open-open-value]").dataset.toggleOpenOpenValue = String(enabled)
  }

  #smsUnavailable() {
    return this.emailOnlyEventTypeIdsValue.includes(this.eventTypeTarget.value)
  }

  #toggleSmsCard() {
    if (!this.hasSmsCardTarget) return

    const unavailable = this.#smsUnavailable()

    this.smsCardTarget.classList.toggle("hidden", unavailable)
    this.smsUnavailableNoteTarget.classList.toggle("hidden", !unavailable)
  }
}
